import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Radio,
  alpha,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

interface AppearanceTabProps {
  colors: any;
  glassStyle: any;
  mode: string;
  toggleTheme: () => void;
}

const AppearanceTab: React.FC<AppearanceTabProps> = ({ colors, glassStyle, mode, toggleTheme }) => {
  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Appearance
      </Typography>
      <Typography color={colors.textSecondary} sx={{ mb: 4 }}>
        Customize the look and feel of the app.
      </Typography>
      
      <Typography variant="subtitle2" color={colors.textSecondary} sx={{ mb: 2, textTransform: 'uppercase', fontWeight: 800, fontSize: '0.75rem' }}>
        Theme
      </Typography>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid size={{ xs: 4 }}>
          <Box 
            onClick={() => { if(mode === 'dark') toggleTheme() }}
            sx={{ 
              border: mode === 'light' ? `2px solid ${colors.success}` : `2px solid transparent`,
              borderRadius: '16px', 
              overflow: 'hidden', 
              cursor: 'pointer', 
              position: 'relative',
              display: 'flex', 
              flexDirection: 'column'
            }}
          >
            <Box sx={{ height: 100, width: 100, bgcolor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Box sx={{ width: '80%', height: '60%', bgcolor: '#E3E5E8', borderRadius: 2 }} />
            </Box>
            <Box sx={{ p: 1.5, bgcolor: colors.cardBg }}>
              <Typography align="center" fontWeight={700} color={colors.textPrimary}>Light</Typography>
            </Box>
            {mode === 'light' && <CheckCircle sx={{ position: 'absolute', top: 8, right: 8, color: colors.success }} />}
          </Box>
        </Grid>
        <Grid size={{ xs: 4 }}>
          <Box 
            onClick={() => { if(mode === 'light') toggleTheme() }}
            sx={{ 
              border: mode === 'dark' ? `2px solid ${colors.success}` : `2px solid transparent`,
              borderRadius: '16px', 
              overflow: 'hidden', 
              cursor: 'pointer', 
              position: 'relative',
              display: 'flex', 
              flexDirection: 'column'
            }}
          >
            <Box sx={{ height: 100, width: 100, bgcolor: '#313338', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Box sx={{ width: '80%', height: '60%', bgcolor: '#2B2D31', borderRadius: 2 }} />
            </Box>
            <Box sx={{ p: 1.5, bgcolor: colors.cardBg }}>
              <Typography align="center" fontWeight={700} color={colors.textPrimary}>Dark</Typography>
            </Box>
            {mode === 'dark' && <CheckCircle sx={{ position: 'absolute', top: 8, right: 8, color: colors.success }} />}
          </Box>
        </Grid>
      </Grid>

      <Typography variant="subtitle2" color={colors.textSecondary} sx={{ mb: 2, textTransform: 'uppercase', fontWeight: 800, fontSize: '0.75rem' }}>
        Message Display
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 0, overflow: 'hidden', ...glassStyle }}>
        <Box sx={{ p: 2, borderBottom: `1px solid ${colors.borderColor}`, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Radio checked={true} color="success" />
          <Box>
            <Typography fontWeight={700} color={colors.textPrimary}>Cozy</Typography>
            <Typography variant="body2" color={colors.textSecondary}>Modern, beautiful, and easy on your eyes.</Typography>
          </Box>
        </Box>
        <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Radio checked={false} color="default" />
          <Box>
            <Typography fontWeight={700} color={colors.textPrimary}>Compact</Typography>
            <Typography variant="body2" color={colors.textSecondary}>Fit more messages on screen at once.</Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AppearanceTab;